<template>
  <v-container>
    <v-layout row wrap align-top class="text-xs-center">
      <v-flex xs12 >
        <v-img
          height="200px"
          contain
          :src="require('../assets/winterwarrior.png')"
        ></v-img>
      </v-flex>
      <v-flex xs12 class="pa-2">
        <h2>2025 Winter Warrior Tournament</h2>
        <h3>Saturday, December 6th at 11:30 AM</h3>
        <h3>Crossfit TILT, Sudbury</h3>
      </v-flex>
      <v-flex xs12>
        <h3>Events:</h3>
        Sparring<br />
        Jumping<br />
        Board Breaking<br />
        Patterns<br />
      </v-flex>
      <v-flex xs12>
        <h3>Tournament pricing are as follows:</h3>
        <h4>1 event  $20</h4>
        <h4>2 events $35</h4>
        <h4>3 events $50</h4>
        <h4>4 events $60</h4>
        <h3>Payment due at time of registration. Registration due by 11/25.</h3>
      </v-flex>
      <v-flex xs12>
        <v-btn
          large
          color="primary"
          class="mx-0"
          to="/pay"

        >Go to Payments</v-btn>
      </v-flex>
      <v-flex xs12 >
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScsR3u-gIzXX2o2NY5pJrr_0bT11IMY1Wd5zRe0gHSo1fSJJA/viewform" width="375" height="1400" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
      </v-flex>
      <v-flex xs12>
        <v-btn
          large
          color="primary"
          class="mx-0"
          to="/pay"

        >Go to Payments</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    computed: {
      size () {
        const binding = {}
        if (this.$vuetify.breakpoint.xsOnly) binding.column = true
        return binding
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
select {
appearance: menulist;
}
table {
    margin: auto;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/popup.vue